import { Outlet } from "react-router";

export default function ApplicationLayout() {
  return (
    <main className="d-flex flex-column flex-grow-1">
      <Outlet />
    </main>
  );
}
